import { LinkOutlined, MenuBookOutlined, OpenInNewOutlined, VpnKeyOutlined } from "@mui/icons-material";
import CopyToClipboardButton from "components/shared/CopyToClipboardButton";
import { useTranslation } from "react-i18next";

const publicApiV2BaseUrl = () => String(import.meta.env.REACT_APP_API_ENDPOINT_V2 ?? "").replace(/\/$/, "");

const ApiKeyGuide = () => {
    const [t, i18n] = useTranslation();
    const apiV2BaseUrl = publicApiV2BaseUrl();
    const docsLocale = i18n.language?.toLowerCase().startsWith("en") ? "en" : "fr";
    const publicDocsUrl = `${apiV2BaseUrl}/public/${docsLocale}`;

    return (
        <div className="apikey-guide-block">
            <p className="apikey-guide-intro">{t("Settings.APIKey.Intro")}</p>
            <div className="apikey-guide">
                <div className="apikey-guide-item">
                    <span className="apikey-guide-label">
                        <MenuBookOutlined />
                        {t("Settings.APIKey.DocsLabel")}
                    </span>
                    <a className="apikey-guide-link" href={publicDocsUrl} target="_blank" rel="noreferrer noopener">
                        {t("Settings.APIKey.PublicAPI")}
                        <OpenInNewOutlined />
                    </a>
                </div>
                <div className="apikey-guide-item">
                    <span className="apikey-guide-label">
                        <LinkOutlined />
                        {t("Settings.APIKey.BaseUrlLabel")}
                    </span>
                    <span className="apikey-guide-value">
                        <code title={apiV2BaseUrl}>{apiV2BaseUrl}</code>
                        <CopyToClipboardButton color="" value={apiV2BaseUrl} style={{ height: 12, width: 12 }} />
                    </span>
                </div>
                <div className="apikey-guide-item">
                    <span className="apikey-guide-label">
                        <VpnKeyOutlined />
                        {t("Settings.APIKey.TokenLabel")}
                    </span>
                    <span className="apikey-guide-value">
                        <code>{t("Settings.APIKey.AuthHeader")}</code>
                    </span>
                    <span className="apikey-guide-hint">{t("Settings.APIKey.TokenHelp")}</span>
                </div>
            </div>
        </div>
    );
};

export default ApiKeyGuide;
